import { put, takeLatest } from "redux-saga/effects";
import {
  fetchCNInvoiceListRequest,
  fetchCNInvoiceListFailure,
  fetchCNInvoiceListSuccess,
  fetchGeneratedCreditNoteListRequest,
  fetchGeneratedCreditNoteListSuccess,
  fetchGeneratedCreditNoteListFailure,
  fetchDraftCreditNoteListRequest,
  fetchDraftCreditNoteListSuccess,
  fetchDraftCreditNoteListFaliure,
  createCreditNoteRequest,
  createCreditNoteSuccess,
  createCreditNoteFaliure,
  deleteCreditNoteRequest,
  deleteCreditNoteSuccess,
  deleteCreditNoteFaliure,
  fetchCreditNoteDetailListRequest,
  fetchCreditNoteDetailListSuccess,
  fetchCreditNoteDetailListFailure,
  updateCreditNoteStageFaliure,
  updateCreditNoteStageSuccess,
  updateCreditNoteStageRequest,
  editCreditNoteRequest,
  editCreditNoteFaliure,
  editCreditNoteSuccess,
  fetchEcreditNoteRequest,
  fetchEcreditNoteSuccess,
  fetchEcreditNoteFailure,
  fetchCancelCreditNoteRequest,
  fetchCancelCreditNoteSuccess,
  fetchCancelCreditNoteFailure,
  fetchFiniancialCreditNoteRequest,
  fetchFiniancialCreditNoteSuccess,
  fetchFiniancialCreditNoteFailure,
} from "redux/reducers/acclgl/creditNotes";

import {
  requestCNInvoiceList,
  requestGeneratedCreditNoteList,
  requestDraftCreditNoteList,
  createCrediNote,
  deleteCreditNoteService,
  requestCreditNoteDetailList,
  updateCreditNoteStage,
  editCreditNote,
  generateEcreditNote,
  cancelCreditNote,
  requestFiniancialCreditNote,
} from "services/acclgl/creditNotes";

export function* watchCreditNoteSaga() {
  yield takeLatest(fetchCNInvoiceListRequest, fetchInvoiceList);
  yield takeLatest(
    fetchGeneratedCreditNoteListRequest,
    fetchGeneratedCreditNoteList
  );
  yield takeLatest(fetchDraftCreditNoteListRequest, fetchDraftCreditNoteList);
  yield takeLatest(createCreditNoteRequest, createCreditNote);
  yield takeLatest(deleteCreditNoteRequest, deleteCreditNote);
  yield takeLatest(fetchCreditNoteDetailListRequest, fetchCreditNoteDetailList);
  yield takeLatest(updateCreditNoteStageRequest, updateStageCreditNote);
  yield takeLatest(editCreditNoteRequest, editCreditNoteSaga);
  yield takeLatest(fetchEcreditNoteRequest, ecreditNoteSaga);
  yield takeLatest(fetchCancelCreditNoteRequest, cancelCreditNoteSaga);
  yield takeLatest(fetchFiniancialCreditNoteRequest, finiancialCreditNoteSaga);
}

function* fetchInvoiceList({ payload }) {
  try {
    const response = yield requestCNInvoiceList(payload);
    yield put(fetchCNInvoiceListSuccess(response));
  } catch (error) {
    const message = error.message || "Failed to get List of Invoice";
    yield put(fetchCNInvoiceListFailure(message));
  }
}

function* fetchGeneratedCreditNoteList({ payload }) {
  try {
    const response = yield requestGeneratedCreditNoteList(payload);
    yield put(fetchGeneratedCreditNoteListSuccess(response));
  } catch (error) {
    const message = error.message || "Failed to Create  Credit Note";
    yield put(fetchDraftCreditNoteListFaliure(message));
  }
}

function* fetchDraftCreditNoteList({ payload }) {
  try {
    const response = yield requestDraftCreditNoteList(payload);
    yield put(fetchDraftCreditNoteListSuccess(response));
  } catch (error) {
    const message = error.message || "Failed to get List of Credit Note";
    yield put(createCreditNoteFaliure(message));
  }
}

function* createCreditNote({ payload }) {
  try {
    const response = yield createCrediNote(payload);
    yield put(createCreditNoteSuccess(response));
  } catch (error) {
    const message =
      error?.response?.data?.data || "Failed to create Credit Note";
    yield put(createCreditNoteFaliure(message));
  }
}
function* deleteCreditNote({ payload }) {
  try {
    const response = yield deleteCreditNoteService(payload);
    yield put(deleteCreditNoteSuccess(response));
  } catch (error) {
    const message =
      error?.response?.data?.data || "Failed to Delete  Credit Note";
    yield put(deleteCreditNoteFaliure(message));
  }
}

function* fetchCreditNoteDetailList({ payload }) {
  try {
    const response = yield requestCreditNoteDetailList(payload);
    yield put(fetchCreditNoteDetailListSuccess(response));
  } catch (error) {
    const message =
      error?.response?.data?.data?.message ||
      "Failed to get List of Credit Note";
    yield put(fetchCreditNoteDetailListFailure(message));
  }
}

function* updateStageCreditNote({ payload }) {
  try {
    const response = yield updateCreditNoteStage(payload);
    yield put(updateCreditNoteStageSuccess(response.data));
  } catch (error) {
    const message =
      error?.response?.data?.data || "Failed to update Credit Note Stage";
    yield put(updateCreditNoteStageFaliure(message));
  }
}

function* editCreditNoteSaga({ payload }) {
  try {
    const response = yield editCreditNote(payload);
    yield put(editCreditNoteSuccess(response));
  } catch (error) {
    const message = error?.response?.data?.data || "Failed to edit Credit Note";
    yield put(editCreditNoteFaliure(message));
  }
}

function* ecreditNoteSaga({ payload }) {
  try {
    const response = yield generateEcreditNote(payload);
    yield put(fetchEcreditNoteSuccess(response));
  } catch (error) {
    const message =
      error?.response?.data?.data || "Failed to E-generate Credit Note";
    yield put(fetchEcreditNoteFailure(message));
  }
}

function* cancelCreditNoteSaga({ payload }) {
  try {
    const response = yield cancelCreditNote(payload);
    yield put(fetchCancelCreditNoteSuccess(response));
  } catch (error) {
    const message =
      error?.response?.data?.data || "Failed to Cancel Credit Note";
    yield put(fetchCancelCreditNoteFailure(message));
  }
}

function* finiancialCreditNoteSaga({ payload }) {
  try {
    const response = yield requestFiniancialCreditNote(payload);
    yield put(fetchFiniancialCreditNoteSuccess(response));
  } catch (error) {
    yield put(
      fetchFiniancialCreditNoteFailure(
        "Failed to Generate Finiancial Credit Note"
      )
    );
  }
}
